import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/sales-channels/mobile-app/design/')({});
